import { render, staticRenderFns } from "./institution-tab.vue?vue&type=template&id=c9f2d81e&scoped=true"
import script from "./institution-tab.vue?vue&type=script&lang=js"
export * from "./institution-tab.vue?vue&type=script&lang=js"
import style0 from "./institution-tab.vue?vue&type=style&index=0&id=c9f2d81e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f2d81e",
  null
  
)

export default component.exports